export const DE = "de";
export const EN = "en";
export const DEFAULT_LANGUAGE = DE;

export const LANGUAGE_ENUM = [
  { key: DE, label: "Deutsch", value: "DE" },
  { key: EN, label: "English", value: "EN" },
];
